import { MatDialogModule } from '@angular/material/dialog';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CopyToClipboardService } from 'src/app/services/copy-to-clipboard.service';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';


export interface IExamInformation {
  examName: string,
  subject: string,
  time: {
    // startTime: Date;
    // endTime: Date;
    endTime: string;
    availableTime: string;
    showAvailableTime: boolean;
  };
  attachments: string[];
  drafts: {
    allowed: boolean;
    included: boolean;
  };
  availableFeatures: AsgardFeatureNames[];
  goToFullscreenHandler: () => void;
}

@Component({
    selector: 'asg-exam-information-dialog',
    templateUrl: './exam-information-dialog.component.html',
    styleUrls: ['./exam-information-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, TranslateModule]
})
export class ExamInformationDialogComponent {
  @ViewChild('okButton') okButton: MatButton;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IExamInformation, 
    private readonly translate: TranslateService,
    private readonly copyToClipboardService: CopyToClipboardService)
   { }

  async confirm(): Promise<void> {
    await this.overwriteClipboard();
    this.data.goToFullscreenHandler();
  }

  private async overwriteClipboard(): Promise<void> {
    // Error: Document is not focused
    // This error happens in Chrome when there is delay in writing to clipboard and user is not focusing on the window.
    if (!document.hasFocus()) {
      console.log('Document was not focused, set focus on okButton');
      this.okButton.focus();
    }
    // copy default text to clipboard
    const message = this.translate.instant('EXAM_RESTRICTIONS.GENERAL.CLIPBOARD_MESSAGE');
    await this.copyToClipboardService.copy(message)
    .catch((error) => console.error(error));
  }

}
